import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { WebsiteFacades } from './website-feature.facades';
import { WebsiteEffects } from './website-feature.effects';
import { WEBSITE_FEATURE_KEY, websiteReducer } from './website-feature.reducer';

@NgModule({
    declarations: [],
    imports: [StoreModule.forFeature(WEBSITE_FEATURE_KEY, websiteReducer), EffectsModule.forFeature(WebsiteEffects)],
    providers: [...WebsiteFacades],
})
export class WebsiteStoreModule {}
